import React from 'react';
interface AppBadgeProps {
  children: ReactNode;
  variant?: 'default' | 'green' | 'amber' | 'red' | 'blue';
  size?: 'sm' | 'md';
  icon?: ReactNode;
  className?: string;
}
export function AppBadge({
  children,
  variant = 'default',
  size = 'sm',
  icon,
  className = ''
}: AppBadgeProps) {
  const variantClasses: Record<BadgeVariant, string> = {
    default: 'bg-white/[0.04] text-white/70 border border-white/[0.08] rounded-full',
    primary: 'bg-[#8eff01] text-black font-medium rounded-full',
    secondary: 'bg-white/[0.06] text-white/60 border border-white/[0.08] rounded-full',
    success: 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 rounded-full',
    warning: 'bg-amber-500/10 text-amber-400 border border-amber-500/20 rounded-full',
    danger: 'bg-red-500/10 text-red-400 border border-red-500/20 rounded-full',
    info: 'bg-blue-500/10 text-blue-400 border border-blue-500/20 rounded-full',
    outline: 'bg-transparent text-white/60 border border-white/[0.08] rounded-full'
  };
  const sizeClasses: Record<BadgeSize, string> = {
    sm: 'px-3 py-0.5 text-xs',
    md: 'px-4 py-1.5 text-xs',
    lg: 'px-5 py-2 text-sm'
  };
  return;
}